// extracted by mini-css-extract-plugin
export default {"main":"CardItem_main__1tX7T","content":"CardItem_content__ING2P","arrow":"CardItem_arrow__M5+R9","skill":"CardItem_skill__CVMzb"};